import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import ProtectedRoutes from "./Components/Routes/ProtectedRoutes";

const App = () => {
  return (
    <>
      <ProtectedRoutes />
    </>
  );
};

export default App;
